import React, { useContext } from 'react'
import { Switch } from 'react-router-dom'

import { PrivateRoutes } from './Index'

import CartChangeFiltersContextProvider from '../context/CartChangeFiltersContext'
import { AuthContext } from '../context/AuthContext'

import CartChangeOverview from '../pages/CartChange/Index'

export default function CartChangeRoutes (): JSX.Element {
  const { auth } = useContext(AuthContext)
  return (
    <CartChangeFiltersContextProvider>
      <Switch>
        <PrivateRoutes path="/mudanca-de-cesta/overview" component={CartChangeOverview} auth={auth} />
      </Switch>
    </CartChangeFiltersContextProvider>
  )
}
